
import { AppData } from '../types';

// DATA MATERI TAJWID LENGKAP (INJECTED)
const LOCAL_DATA: AppData = {
  introduction: {
    definisi: "Ilmu Tajwid adalah ilmu yang mempelajari tata cara membaca Al-Quran dengan baik dan benar, memberikan hak-hak huruf (sifat asli) dan mustahaq-nya (sifat yang muncul sewaktu-waktu).",
    tujuan: "Menjaga lisan dari kesalahan (Al-Lahn) saat membaca Kalamullah dan mencapai kebahagiaan dunia akhirat.",
    obyek: "Kata-kata di dalam Al-Quran (Huruf Hijaiyah).",
    hukum: "Fardhu 'Ain (Membaca dengan Tajwid) & Fardhu Kifayah (Mempelajari Teori)."
  },
  makhraj: [
    // GROUP 1: TENGGOROKAN (Blue/Teal)
    {
      id: 1,
      kategori: "TENGGOROKAN",
      deskripsi: "Aqshal Halq (Pangkal Tenggorokan)",
      huruf: ["أ", "هـ"]
    },
    {
      id: 2,
      kategori: "TENGGOROKAN",
      deskripsi: "Wasthul Halq (Tengah Tenggorokan)",
      huruf: ["ع", "ح"]
    },
    {
      id: 3,
      kategori: "TENGGOROKAN",
      deskripsi: "Adnal Halq (Ujung Tenggorokan)",
      huruf: ["غ", "خ"]
    },
    
    // GROUP 2: KERONGKONGAN (Gold/Yellow) - Poster Label
    {
      id: 4,
      kategori: "KERONGKONGAN",
      deskripsi: "Pangkal Lidah (Menyentuh Langit-langit Lunak)",
      huruf: ["ق"]
    },
    {
      id: 5,
      kategori: "KERONGKONGAN",
      deskripsi: "Pangkal Lidah (Bawah Qaf)",
      huruf: ["ك"]
    },

    // GROUP 3: LIDAH (Peach/Orange)
    {
      id: 6,
      kategori: "LIDAH",
      deskripsi: "Wastul Lisan (Tengah Lidah)",
      huruf: ["ج", "ش", "ي"]
    },
    {
      id: 7,
      kategori: "LIDAH",
      deskripsi: "Hafatul Lisan (Sisi Lidah)",
      huruf: ["ض"]
    },
    {
      id: 8,
      kategori: "LIDAH",
      deskripsi: "Ujung Sisi Lidah (Gusi Atas)",
      huruf: ["ل"]
    },
    {
      id: 9,
      kategori: "LIDAH",
      deskripsi: "Ujung Lidah (Gusi Atas)",
      huruf: ["ن"]
    },
    {
      id: 10,
      kategori: "LIDAH",
      deskripsi: "Ujung Lidah (Punggung Lidah)",
      huruf: ["ر"]
    },
    {
      id: 11,
      kategori: "LIDAH",
      deskripsi: "Ujung Lidah (Pangkal Gigi Seri Atas)",
      huruf: ["ط", "د", "ت"]
    },
    {
      id: 14, // Sesuai urutan visual poster biasanya 14 di bawah
      kategori: "LIDAH",
      deskripsi: "Ujung Lidah (Dinding Gigi Seri Bawah)",
      huruf: ["ص", "س", "ز"]
    },
    {
      id: 15,
      kategori: "LIDAH",
      deskripsi: "Ujung Lidah (Ujung Gigi Seri Atas)",
      huruf: ["ظ", "ذ", "ث"]
    },

    // GROUP 4: BIBIR (Muted Blue)
    {
      id: 13, // Fa biasanya no 15/13 tergantung urutan, di poster ini 13
      kategori: "BIBIR",
      deskripsi: "Bibir Bawah & Gigi Seri Atas",
      huruf: ["ف"]
    },
    {
      id: 12,
      kategori: "BIBIR",
      deskripsi: "Dua Bibir",
      huruf: ["م", "ب", "و"]
    },

    // GROUP 5: RONGGA MULUT (Light Blue)
    {
      id: 16,
      kategori: "RONGGA MULUT",
      deskripsi: "Al-Jauf (Huruf Mad)",
      huruf: ["ا", "و", "ي"]
    },

    // GROUP 6: HIDUNG (Brown)
    {
      id: 17,
      kategori: "HIDUNG",
      deskripsi: "Al-Khaishum (Ghunnah/Dengung)",
      huruf: ["Ghunnah"]
    }
  ],
  sifat: [
    {
      no: 1,
      sifat: "Mahmusah (Hams)",
      keterangan: "Mendesis / Bunyi huruf disertai keluarnya nafas.",
      huruf: ["ف", "ح", "ث", "ه", "ش", "خ", "ص", "س", "ك", "ت"]
    },
    {
      no: 2,
      sifat: "Majhurah (Jahr)",
      keterangan: "Nyaring / Bunyi huruf ditekan, nafas tertahan.",
      huruf: ["ا", "ب", "ج", "د", "ذ", "ر", "ز", "ض", "ظ", "ع", "غ", "ل", "م", "ن", "و", "ي"]
    },
    {
      no: 3,
      sifat: "Syadidah",
      keterangan: "Keras / Bunyi huruf ditekan keluar dan dikeraskan.",
      huruf: ["ا", "ب", "ت", "د", "ض", "ط", "ق", "ك"]
    },
    {
      no: 4,
      sifat: "Muthbiqah (Itbaq)",
      keterangan: "Terkatup / Lidah menempel ke langit-langit mulut.",
      huruf: ["ص", "ض", "ط", "ظ"]
    },
    {
      no: 5,
      sifat: "Layyin",
      keterangan: "Lunak / Lembut.",
      huruf: ["و", "ي"]
    },
    {
      no: 6,
      sifat: "Qalqalah",
      keterangan: "Bergetar, melentur, memantul saat sukun.",
      huruf: ["ب", "ج", "د", "ط", "ق"]
    },
    {
      no: 7,
      sifat: "Shafir",
      keterangan: "Suara berdesis menyerupai suara burung/lebah.",
      huruf: ["ص", "س", "ز"]
    }
  ],
  rules: [
    // --- 1. HUKUM NUN SUKUN / TANWIN ---
    {
      category: "1_NUN_SUKUN",
      categoryName: "1. Hukum Nun Sukun & Tanwin",
      nama: "Izhar Halqi",
      arti: "Jelas di Tenggorokan",
      syarat: "Nun Sukun / Tanwin bertemu huruf Halqi: ء ه ع ح غ خ",
      huruf: ["ء", "ه", "ع", "ح", "غ", "خ"],
      caraBaca: "Bunyi 'N' dibaca jelas (terang) tanpa dengung dan tidak samar.",
      contoh: [
        { teks: "مَنْ آمَنَ", latin: "Man Aamana", keterangan: "Nun mati bertemu Hamzah" },
        { teks: "عَذَابٌ أَلِيمٌ", latin: "'Adzaabun Aliim", keterangan: "Tanwin bertemu Hamzah" },
        { teks: "مِنْ عِلْمٍ", latin: "Min 'Ilmin", keterangan: "Nun mati bertemu 'Ain" },
        { teks: "عَذَابٌ غَلِيظٌ", latin: "'Adzaabun Ghaliizh", keterangan: "Tanwin bertemu Ghain" }
      ]
    },
    {
      category: "1_NUN_SUKUN",
      categoryName: "1. Hukum Nun Sukun & Tanwin",
      nama: "Idgham Bi Ghunnah",
      arti: "Melebur dengan Dengung",
      syarat: "Nun Sukun / Tanwin bertemu huruf: ي ن م و",
      huruf: ["ي", "ن", "م", "و"],
      caraBaca: "Bunyi 'N' dilebur/dimasukkan ke dalam huruf berikutnya dengan cara mendengung (ditekan dan ditahan 2 harakat).",
      contoh: [
        { teks: "مَنْ يَقُولُ", latin: "May-Yaquulu", keterangan: "Nun mati bertemu Ya" },
        { teks: "مِنْ مَسَدٍ", latin: "Mim-Masadin", keterangan: "Nun mati bertemu Mim" },
        { teks: "خَيْرٌ وَأَبْقَى", latin: "Khairuw-wa abqaa", keterangan: "Tanwin bertemu Wawu" },
        { teks: "وَلَنْ نُؤْمِنَ", latin: "Wa lan-Nu'mina", keterangan: "Nun mati bertemu Nun" }
      ]
    },
    {
      category: "1_NUN_SUKUN",
      categoryName: "1. Hukum Nun Sukun & Tanwin",
      nama: "Idgham Bi Laa Ghunnah",
      arti: "Melebur Tanpa Dengung",
      syarat: "Nun Sukun / Tanwin bertemu huruf: ل ر",
      huruf: ["ل", "ر"],
      caraBaca: "Bunyi 'N' dilebur/dimasukkan ke dalam huruf berikutnya dengan cara tidak mendengung (suara N hilang).",
      contoh: [
        { teks: "مِنْ رَبِّهِمْ", latin: "Mir-Rabbihim", keterangan: "Nun mati bertemu Ra" },
        { teks: "غَفُورٌ رَحِيمٌ", latin: "Ghafuurur-Rahiim", keterangan: "Tanwin bertemu Ra" },
        { teks: "وَلَمْ يَكُنْ لَهُ", latin: "Walam Yakul-Lahu", keterangan: "Nun mati bertemu Lam" },
        { teks: "خَيْرٌ لَكُمْ", latin: "Khairul-Lakum", keterangan: "Tanwin bertemu Lam" }
      ]
    },
    {
      category: "1_NUN_SUKUN",
      categoryName: "1. Hukum Nun Sukun & Tanwin",
      nama: "Iqlab",
      arti: "Menukar / Mengganti",
      syarat: "Nun Sukun / Tanwin bertemu huruf: ب",
      huruf: ["ب"],
      caraBaca: "Bunyi 'N' dibalik/diganti/ditukar menjadi bunyi 'M' (Mim) disertai dengung.",
      contoh: [
        { teks: "مِنْ بَعْدِ", latin: "Mim-Ba'di", keterangan: "Nun mati bertemu Ba" },
        { teks: "بَغْيًا بَيْنَهُمْ", latin: "Baghyam-Bainahum", keterangan: "Tanwin bertemu Ba" }
      ]
    },
    {
      category: "1_NUN_SUKUN",
      categoryName: "1. Hukum Nun Sukun & Tanwin",
      nama: "Ikhfa Haqiqi",
      arti: "Menyamarkan (Benar-benar)",
      syarat: "Nun Sukun / Tanwin bertemu 15 huruf Ikhfa: ت ث ج د ذ ز س ش ص ض ط ظ ف ق ك",
      huruf: ["ت", "ث", "ج", "د", "ذ", "ز", "س", "ش", "ص", "ض", "ط", "ظ", "ف", "ق", "ك"],
      caraBaca: "Bunyi 'N' dibaca samar-samar, tipis/ringan disertai/bersamaan dengan huruf berikutnya (dengung).",
      contoh: [
        { teks: "جَنَّاتٌ تَجْرِي", latin: "Jannaatun Tajrii", keterangan: "Tanwin bertemu Ta" },
        { teks: "أَزْوَاجًا ثَلَاثَةً", latin: "Azwaajan Tsalaatsah", keterangan: "Tanwin bertemu Tsa" },
        { teks: "مَاءً فَتَيَمَّمُوا", latin: "Maa'an Fatayammamu", keterangan: "Tanwin bertemu Fa" },
        { teks: "مِنْ قَبْلِكُمْ", latin: "Min Qablikum", keterangan: "Nun mati bertemu Qaf" }
      ]
    },
    
    // --- 2. HUKUM MIM SUKUN ---
    {
      category: "2_MIM_SUKUN",
      categoryName: "2. Hukum Mim Sukun",
      nama: "Ikhfa Syafawi",
      arti: "Samar di Bibir",
      syarat: "Mim Sukun bertemu huruf: ب",
      huruf: ["ب"],
      caraBaca: "Bunyi 'M' dibaca samar-samar, ringan, tipis (di bibir).",
      contoh: [
        { teks: "عَلَيْهِمْ بِٱلْإِثْمِ", latin: "'Alaihim bil-itsmi", keterangan: "Mim mati bertemu Ba" },
        { teks: "تَرْمِيهِمْ بِحِجَارَةٍ", latin: "Tarmiihim-Bihijaaratin", keterangan: "Mim mati bertemu Ba" }
      ]
    },
    {
      category: "2_MIM_SUKUN",
      categoryName: "2. Hukum Mim Sukun",
      nama: "Idgham Mimi (Mutamatsilain)",
      arti: "Melebur Sesama Mim",
      syarat: "Mim Sukun bertemu huruf: م",
      huruf: ["م"],
      caraBaca: "Bunyi 'M' yang pertama dilebur/dimasukkan ke dalam huruf Mim kedua (seolah hanya ada 1 Mim, ditekan dan ditahan 2 harakat).",
      contoh: [
        { teks: "وَمَا لَهُمْ مِنْ نَاصِرِينَ", latin: "Wa maalahum min...", keterangan: "Mim mati bertemu Mim" },
        { teks: "لَهُمْ مَا كَسَبْتُمْ", latin: "Lahum maa kasabtum", keterangan: "Mim mati bertemu Mim" }
      ]
    },
    {
      category: "2_MIM_SUKUN",
      categoryName: "2. Hukum Mim Sukun",
      nama: "Izhar Syafawi",
      arti: "Jelas di Bibir",
      syarat: "Mim Sukun bertemu huruf SELAIN Mim dan Ba.",
      huruf: ["ء", "ت", "ث", "ج", "ح", "خ", "د", "ذ", "ر", "ز", "س", "ش", "ص", "ض", "ط", "ظ", "ع", "غ", "ف", "ق", "ك", "ل", "ن", "و", "ه", "ي"],
      caraBaca: "Bunyi 'M' dibaca jelas (di bibir).",
      contoh: [
        { teks: "فَلَهُمْ أَجْرٌ غَيْرُ", latin: "Falahum ajrun ghairu", keterangan: "Mim mati bertemu Hamzah" },
        { teks: "لَمْ يَلِدْ وَلَمْ يُولَدْ", latin: "Lam yalid walam yuulad", keterangan: "Mim mati bertemu Ya/Wawu" },
        { teks: "عَلَيْهِمْ فَيَمُوتُوا", latin: "'Alaihim fayamuutuu", keterangan: "Mim mati bertemu Fa" }
      ]
    },

    // --- 3. IDGHAM ---
    {
      category: "3_IDGHAM_LAIN",
      categoryName: "3. Macam-Macam Idgham",
      nama: "Idgham Mutamatsilain",
      arti: "Melebur Dua Huruf Sama",
      syarat: "2 huruf yang sama/semisal (sifat & makhraj) saling bertemu (pertama sukun, kedua hidup).",
      huruf: ["ب-ب", "د-د", "م-م", "dll"],
      caraBaca: "Huruf pertama dilebur atau dimasukkan ke dalam huruf berikutnya (ditekan/syiddah).",
      contoh: [
        { teks: "اِضْرِبْ بِعَصَاكَ", latin: "Idhrib bi'ashaaka", keterangan: "Ba sukun bertemu Ba" },
        { teks: "لَقَدْ دَخَلُوا", latin: "Laqad dakhuluu", keterangan: "Dal sukun bertemu Dal" },
        { teks: "وَلَكُمْ مَا كَسَبْتُمْ", latin: "Walakum-maa kasabtum", keterangan: "Mim sukun bertemu Mim" }
      ]
    },
    {
      category: "3_IDGHAM_LAIN",
      categoryName: "3. Macam-Macam Idgham",
      nama: "Idgham Mutajanisain",
      arti: "Melebur Sejenis (Makhraj Sama, Sifat Beda)",
      syarat: "2 huruf yang sejenis makhrajnya tetapi berlainan sifatnya saling bertemu (pertama sukun, kedua hidup).",
      huruf: ["ت-ط", "ط-ت", "ت-د", "د-ت", "ث-ذ", "ذ-ظ", "ب-م"],
      caraBaca: "Huruf yang pertama dilebur atau dimasukkan ke dalam huruf berikutnya (seolah hanya ada 1 huruf).",
      contoh: [
        { teks: "وَقَالَتْ طَائِفَةٌ", latin: "Wa qaalat-thaaifah", keterangan: "Ta sukun bertemu Tha" },
        { teks: "يَلْهَثْ ذَلِكَ", latin: "Yalhadz-Dzalika", keterangan: "Tsa sukun bertemu Dzal" },
        { teks: "عَبَدْتُمْ", latin: "'Abattum", keterangan: "Dal sukun bertemu Ta" }
      ]
    },
    {
      category: "3_IDGHAM_LAIN",
      categoryName: "3. Macam-Macam Idgham",
      nama: "Idgham Mutaqaribain",
      arti: "Melebur Berdekatan",
      syarat: "2 huruf yang berdekatan makhraj/tempat keluar hurufnya saling bertemu (pertama sukun, kedua hidup).",
      huruf: ["ل-ر", "ق-ك", "ب-م"],
      caraBaca: "Huruf pertama dilebur atau dimasukkan ke dalam huruf berikutnya.",
      contoh: [
        { teks: "اِرْكَبْ مَعَنَا", latin: "Irkam-Ma'ana", keterangan: "Ba sukun bertemu Mim" },
        { teks: "أَلَمْ نَخْلُقْكُمْ", latin: "Alam Nakkhluqkum", keterangan: "Qaf sukun bertemu Kaf" }
      ]
    },

    // --- 4. HUKUM MAD (Sesuai Gambar F1-F4) ---
    {
      category: "4_HUKUM_MAD",
      categoryName: "4. Hukum Mad (Panjang)",
      nama: "Mad Thabi'i",
      arti: "Panjang Biasa",
      syarat: "Jika ada huruf Hijaiyah berbaris Fathah bertemu Alif, Kasrah bertemu Ya sukun/mati, atau Dhammah bertemu Wawu sukun/mati.",
      huruf: ["ا", "و", "ي"],
      caraBaca: "Dibaca panjang sebanyak 2 harakat atau 1 Alif.",
      contoh: [
        { teks: "وَالنَّازِعَاتِ", latin: "Wannaazi'aati", keterangan: "Fathah bertemu Alif" },
        { teks: "رَقِيبٌ عَتِيدٌ", latin: "Raqiibun 'atiid", keterangan: "Kasrah bertemu Ya Sukun" },
        { teks: "حَامِدُونَ", latin: "Haamiduuna", keterangan: "Dhammah bertemu Wawu Sukun" }
      ]
    },
    {
      category: "4_HUKUM_MAD",
      categoryName: "4. Hukum Mad (Panjang)",
      nama: "Mad Wajib Muttashil",
      arti: "Wajib Bersambung",
      syarat: "Jika ada Mad Thabi'i (Fathah bertemu Alif, Kasrah bertemu Ya sukun, Dhammah bertemu Wawu sukun) bertemu dengan huruf Alif/Hamzah dalam satu suku kata.",
      huruf: ["ء"],
      caraBaca: "Dibaca panjang menjadi 6 harakat atau 3 Alif.",
      contoh: [
        { teks: "مِنَ السَّمَاءِ مَاءً", latin: "Minassamaa-i maa-an", keterangan: "Satu kata" },
        { teks: "سِيئَ بِهِمْ", latin: "Sii-a bihim", keterangan: "Satu kata" },
        { teks: "مِنْ غَيْرِ سُوءٍ", latin: "Min ghairi suu-in", keterangan: "Satu kata" }
      ]
    },
    {
      category: "4_HUKUM_MAD",
      categoryName: "4. Hukum Mad (Panjang)",
      nama: "Mad Jaiz Munfashil",
      arti: "Boleh Terpisah",
      syarat: "Jika ada Mad Thabi'i bertemu dengan huruf Alif/Hamzah dalam suku kata yang berbeda (lain kata).",
      huruf: ["ء"],
      caraBaca: "Dibaca panjang menjadi 5 harakat atau 2,5 Alif.",
      contoh: [
        { teks: "يَا أَيُّهَا النَّاسُ", latin: "Yaa ayyuhannaasu", keterangan: "Beda kata" },
        { teks: "يَا بَنِي إِسْرَائِيلَ", latin: "Yaa banii israaiila", keterangan: "Beda kata" },
        { teks: "إِعْلَمُوا أَنَّ اللَّهَ", latin: "I'lamuu annallaaha", keterangan: "Beda kata" }
      ]
    },
    {
      category: "4_HUKUM_MAD",
      categoryName: "4. Hukum Mad (Panjang)",
      nama: "Mad 'Aridh Lissukun",
      arti: "Sukun Tiba-tiba",
      syarat: "Jika ada Mad Thabi'i bertemu dengan huruf yang dibaca mati/sukun karena berada di akhir ayat ataupun waqaf/pemberhentian di tengah ayat.",
      huruf: [],
      caraBaca: "Mad Thabi'i dibaca panjang menjadi 4 harakat atau 2 Alif.",
      contoh: [
        { teks: "خَلَقَ الْإِنْسَانَ", latin: "Khalaqal insaan", keterangan: "Waqaf pada Nun" },
        { teks: "يَوْمِ الدِّينِ", latin: "Yaumiddiin", keterangan: "Waqaf pada Nun" },
        { teks: "هُمُ الْمُفْلِحُونَ", latin: "Humul muflihuun", keterangan: "Waqaf pada Nun" }
      ]
    },

    // --- 5. ALIF LAM (Sesuai Gambar D1-D2) ---
    {
      category: "5_ALIF_LAM",
      categoryName: "5. Hukum Alif Lam (Lam Ta'rif)",
      nama: "Izhar Qamariyah",
      arti: "Alif Lam Jelas",
      syarat: "Yaitu Alif Lam bertemu dengan huruf Alif, Ba, Jim, Ha, Kha, 'Ain, Ghain, Fa, Qaf, Kaf, Mim, Wawu, Ha atau Ya.",
      huruf: ["ا", "ب", "ج", "ح", "خ", "ع", "غ", "ف", "ق", "ك", "م", "و", "ه", "ي"],
      caraBaca: "Bunyi 'L' dibaca jelas.",
      contoh: [
        { teks: "أَلْبَابِ", latin: "Al-Baabi", keterangan: "Alif Lam bertemu Ba" },
        { teks: "أَلْعَصْرِ", latin: "Al-'Ashri", keterangan: "Alif Lam bertemu 'Ain" },
        { teks: "أَلْحَمْدُ", latin: "Al-Hamdu", keterangan: "Alif Lam bertemu Ha" }
      ]
    },
    {
      category: "5_ALIF_LAM",
      categoryName: "5. Hukum Alif Lam (Lam Ta'rif)",
      nama: "Idgham Syamsiyah",
      arti: "Alif Lam Melebur",
      syarat: "Yaitu Alif Lam bertemu dengan huruf Ta, Tsa, Dal, Dzal, Ra, Zai, Sin, Syin, Shad, Dhad, Tha, Zha, Lam, atau Nun.",
      huruf: ["ت", "ث", "د", "ذ", "ر", "ز", "س", "ش", "ص", "ض", "ط", "ظ", "ل", "ن"],
      caraBaca: "Bunyi 'L' dilebur/dimasukkan ke dalam huruf berikutnya (Alif Lam dianggap tidak ada).",
      contoh: [
        { teks: "وَالَّتِينِ", latin: "Wat-Tiini", keterangan: "Alif Lam lebur ke Ta" },
        { teks: "وَالضُّحَى", latin: "Wadh-Dhuhaa", keterangan: "Alif Lam lebur ke Dhad" },
        { teks: "وَآتُوا الزَّكَاةَ", latin: "Wa aatuuz-zakaata", keterangan: "Alif Lam lebur ke Zai" }
      ]
    },

    // --- 6. LAFZUL JALALAH (Sesuai Gambar E1-E2) ---
    {
      category: "6_LAFZUL_JALALAH",
      categoryName: "6. Lafzhul Jalalah (Allah)",
      nama: "Tafkhim (Mufakhamah)",
      arti: "Tebal",
      syarat: "Yaitu jika lafal Allah (Lafzhul Jalaalah) didahului oleh huruf yang berharakat/berbaris Fathah ataupun Dhammah.",
      huruf: ["اللّٰه"],
      caraBaca: "Bunyi 'L' dibaca tebal.",
      contoh: [
        { teks: "قُلْ هُوَ اللَّهُ", latin: "Qul Huwallahu", keterangan: "Didahului Fathah" },
        { teks: "رَسُولُ اللَّهِ", latin: "Rasulullah", keterangan: "Didahului Dhammah" }
      ]
    },
    {
      category: "6_LAFZUL_JALALAH",
      categoryName: "6. Lafzhul Jalalah (Allah)",
      nama: "Tarqiq (Muraqaqah)",
      arti: "Tipis",
      syarat: "Yaitu jika lafal Allah (Lafzhul Jalaalah) didahului oleh huruf yang berharakat/berbaris Kasrah.",
      huruf: ["اللّٰه"],
      caraBaca: "Bunyi 'L' dibaca tipis.",
      contoh: [
        { teks: "بِسْمِ اللّٰهِ", latin: "Bismillaahi", keterangan: "Didahului Kasrah" },
        { teks: "لِلَّهِ", latin: "Lillahi", keterangan: "Didahului Kasrah" }
      ]
    }
  ]
};

export const fetchTajwidData = async (): Promise<AppData> => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(LOCAL_DATA);
    }, 800);
  });
};
